export const a11yProps = (labelId: string, contolId: string, id: string) => ({
	id: `${labelId}-${id}`,
	'aria-controls': `${contolId}-${id}`
});
